import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { LogIn, ShieldAlert } from "lucide-react";
import { Button } from "./ui/button";

interface SessionReplacedDialogProps {
  open: boolean;
  onContinue(): void;
}

export function SessionReplacedDialog({ open, onContinue }: SessionReplacedDialogProps) {
  return (
    <Dialog
      className="auth-required-dialog session-replaced-dialog"
      open={open}
      aria-labelledby="session-replaced-title"
      aria-describedby="session-replaced-description"
    >
      <DialogContent>
        <span className="auth-required-icon session-replaced-icon" aria-hidden="true"><ShieldAlert /></span>
        <DialogTitle id="session-replaced-title">账号已在其他设备登录</DialogTitle>
        <DialogContentText id="session-replaced-description">
          检测到同一账号出现新的登录，本设备作为较早登录的一方已被强制下线。
        </DialogContentText>
        <p className="auth-required-note">如果不是你本人操作，请重新登录后尽快修改密码。</p>
        <DialogActions>
          <Button autoFocus type="button" onClick={onContinue}><LogIn aria-hidden="true" />重新登录</Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
